<template>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-label="Progressbar logo" alt="Progressbar logo" viewBox="0 0 328.5 123" width="100%" height="100%">
    <title>Progressbar logo</title>
    <g>
      <path d=" M 11 120 L 2 111 L 2 48 L 29 48 L 29 66 L 20 75 L 11 75" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 38 75 L 38 57 L 47 48 L 56 48" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 65 57 L 56 66 L 56 84 L 74 84 L 83 75 L 83 57 L 65 57 Z " fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 110 120 L 119 111 L 119 48 L 92 48 L 92 66 L 101 75 L 110 75" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 128 75 L 128 57 L 137 48 L 146 48" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 164 84 L 146 84 L 146 66 L 155 57 L 173 57 L 173 66 L 164 75" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 182 84 L 191 84 L 200 75" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 200 75 L 182 57 L 191 48 L 200 48" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 209 84 L 218 84 L 227 75 L 209 57 L 218 48 L 227 48" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 245 57 L 254 48 L 263 48 L 263 75 L 236 75 L 236 12 L 245 3" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 308 75 L 308 57 L 317 48 L 326 48" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
      <path d=" M 272 48 L 290 48 L 299 57 L 299 75 L 272 75 L 272 66 L 281 57" fill="none" stroke-width="4" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="square"  />
    </g>
</svg>
</template>

<script>
export default {
  name: 'progressbar-logo-refresh',
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ProgressbarLogoRefresh.vue?6eb508dc